// extracted by mini-css-extract-plugin
export default {"wrap":"LayoutFixed_wrap__iOCbI","grow":"LayoutFixed_grow__4U45Y"};